// extracted by mini-css-extract-plugin
export default {"latePaymentFields":"MortgageHistorySection_latePaymentFields__sQK1b","questionCard":"MortgageHistorySection_questionCard__xJRsP","buttons":"MortgageHistorySection_buttons__y4TqP"};